import { Routes, Route } from "react-router-dom";
import PipelineIndex from "./Index";
import BoardView from "./BoardView";

const PipelineRoutes = () => (
  <Routes>
    <Route path="/" element={<PipelineIndex />} />
    <Route path="/:id" element={<BoardView />} />
  </Routes>
);

export default PipelineRoutes;
